// extracted by mini-css-extract-plugin
module.exports = {"container":"allocateMembers_container__37BWu","content":"allocateMembers_content__3xT-z"};